// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__+ersL","modalContent":"styles_modalContent__rF+zk","header":"styles_header__zYX79","title":"styles_title__wCKbs","actions":"styles_actions__dqyNG"};